import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Switch,
  Divider,
} from '@mui/material';
import {
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
  Palette as PaletteIcon,
} from '@mui/icons-material';

import { sensorsService } from '../services/api';
import { useThemeMode } from '../contexts/ThemeContext';

function Settings() {
  const { mode, toggleTheme } = useThemeMode();
  const [sensors, setSensors] = useState([]);

  useEffect(() => {
    loadSensors();
  }, []);

  const loadSensors = async () => {
    try {
      const data = await sensorsService.getAll(true);
      setSensors(data);
    } catch (error) {
      console.error('Error loading sensors:', error);
    }
  };

  return (
    <Box sx={{ p: 2, pt: 8, height: '100%', overflow: 'auto' }}>
      <Grid container spacing={3}>
        {/* Tema */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PaletteIcon color="primary" />
                  <Typography variant="h6">Tema</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LightModeIcon sx={{ color: mode === 'light' ? 'warning.main' : 'text.disabled' }} />
                  <Switch
                    checked={mode === 'dark'}
                    onChange={toggleTheme}
                    color="default"
                  />
                  <DarkModeIcon sx={{ color: mode === 'dark' ? 'primary.main' : 'text.disabled' }} />
                </Box>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {mode === 'light' ? 'Tema chiaro attivo' : 'Tema scuro attivo'}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Informazioni sistema */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Informazioni sistema
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary">Versione</Typography>
                  <Typography variant="body2">1.0.0</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary">Sensori attivi</Typography>
                  <Typography variant="body2">
                    {sensors.filter((s) => s.status?.toUpperCase() === 'ONLINE').length} / {sensors.length}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary">Database</Typography>
                  <Typography variant="body2">PostgreSQL + TimescaleDB</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary">Retention</Typography>
                  <Typography variant="body2">2 anni (raw), 5 anni (aggregati)</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Soglie allarmi default */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Soglie allarmi di default
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Le soglie di allarme possono essere configurate individualmente per ogni sensore
                dalla pagina <strong>Sensori</strong>.
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" display="block" gutterBottom>
                    <strong>Spostamento:</strong> Warning 20mm, Allarme 50mm
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" display="block" gutterBottom>
                    <strong>Qualita GNSS:</strong> Warning PDOP 2, Allarme PDOP 4
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" display="block" gutterBottom>
                    <strong>Batteria:</strong> Warning 30%, Allarme 15%
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" display="block" gutterBottom>
                    <strong>Offline:</strong> Warning 5 min, Allarme 15 min
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" display="block">
                    <strong>Velocita:</strong> Warning 1mm/giorno, Allarme 5mm/giorno
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Settings;
